import { FC, useMemo } from 'react';

interface LinearDashedBorderProps {
  height?: number;
  width?: number;
  strokeWidth?: number;
  dashLength?: number; // length of the dash
  gapLength?: number; // gap between dashes
  rx?: number;
  ry?: number;
}

const LinearDashedBorder: FC<LinearDashedBorderProps> = ({
  height = 198,
  width = 238,
  strokeWidth = 2,
  dashLength = 8,
  gapLength = 4,
  rx = 4,
  ry = 4,
}) => {
  const perimeter = 2 * (width + height - 2 * rx);

  const dashPattern = useMemo(() => {
    const unit = dashLength + gapLength;
    const dashCount = Math.floor(perimeter / unit);
    const adjustedDash = perimeter / dashCount - gapLength;
    return `${adjustedDash} ${gapLength}`;
  }, [perimeter, dashLength, gapLength]);

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      className="pointer-events-none absolute inset-0"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id="borderGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="4.09%" stopColor="#7E77B3" />
          <stop offset="27.63%" stopColor="#8989FF" />
          <stop offset="51.07%" stopColor="#6C9DFF" />
          <stop offset="74.69%" stopColor="#78CFDA" />
          <stop offset="98.23%" stopColor="#9FF4A9" />
        </linearGradient>
      </defs>
      <rect
        x={strokeWidth / 2}
        y={strokeWidth / 2}
        width={width - strokeWidth}
        height={height - strokeWidth}
        fill="transparent"
        stroke="url(#borderGradient)"
        strokeWidth={strokeWidth}
        strokeDasharray={dashPattern}
        rx={rx}
        ry={ry}
      />
    </svg>
  );
};

export default LinearDashedBorder;
